import { DownloadSize } from '@editor/components/DownloadSelectionPopover/types';
import { ConvertedObject } from '@editor/helpers/activeObject/types';
import { Unit } from '@editor/types/DesignState';

export enum DownloadFormat {
  'png' = 'png',
  'jpg' = 'jpg',
  'pdf' = 'pdf',
  'svg' = 'svg',
}

export interface DownloadOptions {
  width: number | null;
  height: number | null;
  dpi: number;
  unit: Unit;
  removeBackground: boolean;
  optimizedQuality: boolean;
  includePrintBleed: boolean;
  includeCropMarks: boolean;
}

export type DimensionsPresentable = Pick<
  NonNullable<ConvertedObject['dimensions']>,
  'width' | 'height'
>;

export interface State {
  processing: Record<DownloadFormat, boolean>;
  options: DownloadOptions;
  setProcessing: ({
    processing,
    format,
  }: {
    processing: boolean;
    format: DownloadFormat;
  }) => void;
  setOptions: (options: Partial<DownloadOptions>) => void;
  resetOptions: () => void;
  dimensionsPresentable: DimensionsPresentable;
  setDimensionsPresentable: (dimensions: DimensionsPresentable) => void;
  isDownloadPopoverOpen: boolean;
  setIsDownloadPopoverOpen: (isOpen: boolean) => void;
  /**
   * make file type in sync between download panel and download selection popover
   */
  fileType: DownloadFormat;
  setFileType: (fileType: DownloadFormat) => void;
  fileMultiplier: DownloadSize;
  setFileMultiplier: (fileMultiplier: DownloadSize) => void;
}
